<template>
  <div class="case-detail" v-if="product">
    <div class="case-name">
        <hr style="height:0px;border:none;border-top:1px solid #d9d9d9;width:300px;float: left;display:inline;margin-top:18px;">
        <span class="titlef2d2d2d" style="font-size: 24px;float: left;display:inline;margin-left:80px;margin-right:80px;">
        {{ product.name }}
        </span>
      <hr style="height:0px;border:none;border-top:1px solid #d9d9d9;width:300px;float: left;display:inline;margin-top:18px;">
    </div>
    <div class="case-description">
      <p>{{ product.description }}</p>
    </div>
    <div class="intro-container">
      <div v-for="(intro, index) in product.intros" :key="index" class="intro-item" :class="{ 'reverse': index % 2 !== 0 }">
        <div class="intro-image">
          <img :src="intro.image" alt="案例图片" class="carousel-image" />
        </div>
        <div style="flex:1">
            <div v-for="(intro, index) in intro.text" :key="index" class="intro-text">
                <img src="~@/assets/products/case_icon_1.png" class="carousel-image" style="margin-right: 10px;" />
                <span>{{ intro }}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="features">
        <div v-for="(feature, index) in product.features" :key="index">
          <a v-if="feature.url" :href="feature.url" target="_blank">{{ feature.text }}</a>
          <span v-else>{{ feature }}</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.case-detail {
  display: flex;
  flex-direction: column;
  align-items: center; /* 水平居中 */
  padding: 20px;
  background-color: #f5f5f5;
}

.case-name {
  text-align: center; /* 水平居中文本 */
  margin-bottom: 20px;
    flex-direction: row;
}

.case-description {
 max-width:60%;
  margin: 20px 0;
  text-align: center; /* 文本居中 */
  line-height: 1.6; /* 设置行高 */
  font-size: 16px;color: #686868;
  display:block;text-indent:2em;letter-spacing: 2px;line-height:1.5;
}

.intro-container {
  width: 100%;
  max-width: 800px;
  margin: 20px 0;
}

.intro-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.intro-item.reverse {
  flex-direction: row-reverse; /* 反转顺序 */
}

.intro-image {
  flex: 1;
  margin-right: 50px;
}

.intro-item.reverse .intro-image {
  margin-right: 0;
  margin-left: 20px;
}

.intro-text {
  text-align: left;
  flex-direction: row;
}

.carousel-image {
  max-width: 100%;
  height: auto;
}
.intro-text span{
	font-size:14px;
	color:#686868;
	margin: 0 0 10px;
	font-family:Microsoft YaHei;
	line-height: 1.6;
}

.features {
  margin-top: 20px;
  width: 100%;
  max-width: 600px;
  text-align: left; /* 文本左对齐 */
}

.features h3 {
  text-align: center; /* 水平居中文本 */
}

.features ul {
  list-style-type: disc;
  padding-left: 20px;
}
</style>